const RU = {
  'feedback.tab.queue': 'Очередь',
  'feedback.tab.reports': 'Отчёты',
  'feedback.tab.qr': 'QR-код',

  'feedback.queue.title': 'Обращения',
  'feedback.queue.empty': 'Обращений нет',
  'feedback.queue.status': 'Статус',
  'feedback.queue.channel': 'Канал',
  'feedback.queue.score': 'Оценка',
  'feedback.queue.category': 'Категория',
  'feedback.queue.created': 'Поступило',
  'feedback.queue.due': 'Срок',
  'feedback.queue.overdueOnly': 'Только просроченные',
  'feedback.queue.unlinkedOnly': 'Без визита',
  'feedback.queue.all': 'Все',
  'feedback.queue.overdue': 'Просрочено',
  'feedback.queue.open': 'Открыть',
  'feedback.queue.refresh': 'Обновить',
  'feedback.queue.tick': 'Прогнать таймеры',
  'feedback.queue.ticked': 'Напоминаний: {reminded}, просрочек: {overdue}',

  'feedback.status.new': 'Новое',
  'feedback.status.assigned': 'Назначено',
  'feedback.status.answered': 'Отвечено',
  'feedback.status.escalated': 'Эскалировано',
  'feedback.status.closed': 'Закрыто',

  'feedback.channel.qr': 'QR',
  'feedback.channel.whatsapp': 'WhatsApp',
  'feedback.channel.app': 'Приложение',
  'feedback.channel.phone': 'Телефон',
  'feedback.channel.import': 'Импорт',

  'feedback.card.title': 'Карточка обращения',
  'feedback.card.text': 'Текст обращения',
  'feedback.card.noText': 'Текста нет, только оценка',
  'feedback.card.visit': 'Визит',
  'feedback.card.noVisit': 'Визит не определён — обращение привязано к объекту и смене',
  'feedback.card.employee': 'Сотрудник',
  'feedback.card.assignee': 'Ответственный',
  'feedback.card.resolution': 'Ответ',
  'feedback.card.close': 'Закрыть карточку',

  'feedback.action.assign': 'Назначить',
  'feedback.action.assignee': 'Ответственный',
  'feedback.action.answer': 'Ответить клиенту',
  'feedback.action.answerText': 'Текст ответа',
  'feedback.action.answerHint':
    'Ответ уходит клиенту сообщением на телефон из профиля: в WhatsApp, если обращение пришло оттуда, иначе по SMS. Если клиент не опознан, ответ не отправляется — свяжитесь с ним сами',
  'feedback.action.categorize': 'Подтвердить категорию',
  'feedback.action.category': 'Категория',
  'feedback.action.reason': 'Причина',
  'feedback.action.noReason': 'Без причины',
  'feedback.action.closeBlocked':
    'Из статуса «{status}» закрыть нельзя. Сначала ответьте клиенту — закрытие возможно только из «Отвечено».',
  'feedback.action.assigneeEmpty': 'Выберите сотрудника',
  'feedback.action.closeIt': 'Закрыть обращение',
  'feedback.action.resolution': 'Итог',
  'feedback.action.escalate': 'Эскалировать',
  'feedback.action.note': 'Основание',

  'feedback.category.suggested': 'предположение',
  'feedback.category.confirmed': 'подтверждено',
  'feedback.category.none': 'не задана',
  'feedback.category.suggestedHint':
    'Категорию предложил алгоритм. Пока её не подтвердил человек, обращение не попадает в отчётность.',
  'feedback.category.mustConfirm': 'Закрыть обращение можно только после подтверждения категории.',

  'feedback.reports.title': 'Отчёты по обращениям',
  'feedback.reports.sla': 'Доля ответов быстрее {hours} ч',
  'feedback.reports.target': 'Цель — не ниже 95 %',
  'feedback.reports.total': 'Всего',
  'feedback.reports.closed': 'Закрыто',
  'feedback.reports.within': 'В срок',
  'feedback.reports.formula': 'Как считаем: {formula}',
  'feedback.reports.shareOfClosed': 'Доля от закрытых',
  'feedback.reports.share': 'Доля',
  'feedback.reports.avg': 'Среднее время ответа, мин',
  'feedback.reports.openOverdue': 'Открытых просроченных',
  'feedback.reports.site': 'Объект',
  'feedback.reports.network': 'Вся сеть',
  'feedback.reports.categories': 'Причины обращений',
  'feedback.reports.reason': 'Причина',
  'feedback.reports.count': 'Количество',
  'feedback.reports.avgScore': 'Средняя оценка',
  'feedback.reports.scores': 'Распределение оценок',
  'feedback.reports.employees': 'По сотрудникам',
  'feedback.reports.employee': 'Сотрудник',
  'feedback.reports.lowScore': 'Низких оценок',
  'feedback.reports.unconfirmed': 'Не подтверждено категорий: {n}',
  'feedback.reports.unlinked': 'Без привязки к визиту: {n}',

  'feedback.qr.title': 'Код для печати',
  'feedback.qr.site': 'Объект',
  'feedback.qr.generate': 'Получить токен',
  'feedback.qr.token': 'Токен формы',
  'feedback.qr.path': 'Ссылка для QR-кода',
  'feedback.qr.hint':
    'Код печатается один раз на объект. Визит и смена определяются по времени сканирования.',

  'feedback.common.loading': 'Загрузка…',
  'feedback.common.nothing': 'Ничего не найдено',
  'feedback.common.required': 'Заполните обязательные поля',
  'feedback.common.forbidden': 'Недостаточно прав для этого раздела',
  'feedback.common.saved': 'Сохранено',
  'feedback.msg.queued': 'в очереди',
  'feedback.msg.sending': 'отправляется',
  'feedback.msg.sent': 'отправлено',
  'feedback.msg.delivered': 'доставлено',
  'feedback.msg.failed': 'не доставлено',
  'feedback.msg.suppressed': 'не отправлено',
  'feedback.tab.escalations': 'Эскалации',
  'feedback.tab.settings': 'Сроки и маршруты',
  'feedback.tab.archive': 'Архив',
  'feedback.qr.preview': 'Так выглядит наклейка',
  'feedback.qr.downloadSvg': 'Скачать SVG для типографии',
  'feedback.qr.downloadPng': 'Скачать PNG',
  'feedback.qr.points': 'Точки внутри объекта',
  'feedback.qr.pointsHint': 'У каждого поста или кассы — свой код. По обращению видно, у какой точки его оставили.',
  'feedback.qr.pointName': 'Название точки',
  'feedback.qr.pointAdd': 'Добавить точку',
  'feedback.qr.pointFeedback': 'Отзывов',
  'feedback.qr.pointRotate': 'Перевыпустить код',
  'feedback.qr.pointRotateHint': 'Старая наклейка перестанет работать',
  'feedback.qr.pointArchive': 'Снять точку',
  'feedback.qr.pointRestore': 'Вернуть',
  'feedback.qr.pointArchived': 'снята',
  'feedback.qr.none': 'Точек нет — работает общий код объекта.',
  'feedback.esc.title': 'Журнал эскалаций',
  'feedback.esc.hint': 'Эскалация создаётся сразу при низкой оценке, по просрочке ответа или вручную, и руководитель получает сообщение. Здесь видно, кому и почему.',
  'feedback.esc.openOnly': 'Только неотвеченные',
  'feedback.esc.reason': 'Причина',
  'feedback.esc.reason.low_score': 'Низкая оценка',
  'feedback.esc.reason.overdue': 'Истёк срок ответа',
  'feedback.esc.reason.manual': 'Вручную',
  'feedback.esc.to': 'Кому',
  'feedback.esc.nobody': 'адресат не определён',
  'feedback.esc.when': 'Когда',
  'feedback.esc.empty': 'Эскалаций нет',
  'feedback.card.escalations': 'Эскалации',
  'feedback.card.notifications': 'Отправленные сообщения',
  'feedback.card.notificationsEmpty': 'По обращению сообщений не отправлялось',
  'feedback.card.contact': 'Контакт для ответа',
  'feedback.set.policy': 'Срок ответа и пороги',
  'feedback.set.policyHint': 'Новый срок действует на обращения, поступившие после сохранения. Уже принятые сохраняют обещанный срок.',
  'feedback.set.scope': 'Для кого',
  'feedback.set.network': 'Вся сеть (по умолчанию)',
  'feedback.set.response': 'Срок ответа, мин',
  'feedback.set.remind': 'Напомнить за, мин',
  'feedback.set.lowScore': 'Эскалировать оценки не выше',
  'feedback.set.visitWindow': 'Окно поиска визита, мин',
  'feedback.set.publicWindow': 'Окно лимита формы, мин',
  'feedback.set.publicMax': 'Отправок с одного адреса в окне',
  'feedback.set.save': 'Сохранить',
  'feedback.set.reset': 'Вернуть к политике сети',
  'feedback.set.override': 'особый срок',
  'feedback.set.rules': 'Правила маршрутизации',
  'feedback.set.rulesHint': 'Правила проверяются по приоритету: первое подходящее назначает ответственного, адресата эскалации и срок.',
  'feedback.set.ruleName': 'Название',
  'feedback.set.ruleSite': 'Объект',
  'feedback.set.ruleAnySite': 'любой',
  'feedback.set.ruleCategory': 'Категория',
  'feedback.set.ruleAny': 'любая',
  'feedback.set.ruleScore': 'Оценка не выше',
  'feedback.set.ruleChannel': 'Канал',
  'feedback.set.ruleAssignee': 'Ответственный',
  'feedback.set.ruleEscalate': 'Эскалация',
  'feedback.set.ruleByRole': 'по роли',
  'feedback.set.ruleEmployee': 'конкретный сотрудник',
  'feedback.set.ruleResponse': 'Свой срок, мин',
  'feedback.set.rulePriority': 'Приоритет',
  'feedback.set.ruleNew': 'Новое правило',
  'feedback.set.ruleEdit': 'Правило маршрутизации',
  'feedback.set.ruleArchived': 'в архиве',
  'feedback.set.ruleArchive': 'В архив',
  'feedback.set.ruleRestore': 'Вернуть',
  'feedback.role.site_manager': 'Управляющий объекта',
  'feedback.role.marketer': 'Маркетолог',
  'feedback.role.network_admin': 'Администратор сети',
  'feedback.arch.title': 'Архив обращений из прежнего сервиса',
  'feedback.arch.hint': 'История, перенесённая из стороннего сервиса. Связей с клиентами и визитами у неё нет — так она пришла из источника.',
  'feedback.arch.search': 'Поиск по тексту',
  'feedback.arch.found': 'Найдено: {n}',
  'feedback.arch.received': 'Получено',
  'feedback.arch.subject': 'Тема',
  'feedback.arch.resolution': 'Ответ',
  'feedback.arch.prev': 'Назад',
  'feedback.arch.next': 'Дальше',
  'feedback.arch.empty': 'В архиве ничего не найдено',
  'feedback.sum.title': 'Сводка за период',
  'feedback.sum.hint': 'Текст собирается из тех же чисел, что и отчёты ниже, цитаты — дословно из отзывов. Языковая модель не используется.',
  'feedback.sum.week': '7 дней',
  'feedback.sum.month': '30 дней',
  'feedback.sum.copy': 'Скопировать',
  'feedback.sum.copied': 'Сводка скопирована',

} as const;

const KK: Record<keyof typeof RU, string> = {
  'feedback.tab.queue': 'Кезек',
  'feedback.tab.reports': 'Есептер',
  'feedback.tab.qr': 'QR-код',

  'feedback.queue.title': 'Өтініштер',
  'feedback.queue.empty': 'Өтініштер жоқ',
  'feedback.queue.status': 'Күйі',
  'feedback.queue.channel': 'Арна',
  'feedback.queue.score': 'Баға',
  'feedback.queue.category': 'Санат',
  'feedback.queue.created': 'Түсті',
  'feedback.queue.due': 'Мерзімі',
  'feedback.queue.overdueOnly': 'Тек мерзімі өткен',
  'feedback.queue.unlinkedOnly': 'Келусіз',
  'feedback.queue.all': 'Барлығы',
  'feedback.queue.overdue': 'Мерзімі өткен',
  'feedback.queue.open': 'Ашу',
  'feedback.queue.refresh': 'Жаңарту',
  'feedback.queue.tick': 'Таймерлерді жүргізу',
  'feedback.queue.ticked': 'Еске салу: {reminded}, мерзімі өткен: {overdue}',

  'feedback.status.new': 'Жаңа',
  'feedback.status.assigned': 'Тағайындалған',
  'feedback.status.answered': 'Жауап берілген',
  'feedback.status.escalated': 'Эскалацияланған',
  'feedback.status.closed': 'Жабылған',

  'feedback.channel.qr': 'QR',
  'feedback.channel.whatsapp': 'WhatsApp',
  'feedback.channel.app': 'Қосымша',
  'feedback.channel.phone': 'Телефон',
  'feedback.channel.import': 'Импорт',

  'feedback.card.title': 'Өтініш картасы',
  'feedback.card.text': 'Өтініш мәтіні',
  'feedback.card.noText': 'Мәтін жоқ, тек баға',
  'feedback.card.visit': 'Келу',
  'feedback.card.noVisit': 'Келу анықталмады — өтініш нысан мен ауысымға байланған',
  'feedback.card.employee': 'Қызметкер',
  'feedback.card.assignee': 'Жауапты',
  'feedback.card.resolution': 'Жауап',
  'feedback.card.close': 'Картаны жабу',

  'feedback.action.assign': 'Тағайындау',
  'feedback.action.assignee': 'Жауапты',
  'feedback.action.answer': 'Клиентке жауап беру',
  'feedback.action.answerText': 'Жауап мәтіні',
  'feedback.action.answerHint':
    'Жауап клиенттің профиліндегі телефонға жіберіледі: өтініш WhatsApp-тан келсе — WhatsApp-қа, әйтпесе SMS-пен. Клиент анықталмаса, жауап жіберілмейді — онымен өзіңіз байланысыңыз',
  'feedback.action.categorize': 'Санатты растау',
  'feedback.action.category': 'Санат',
  'feedback.action.reason': 'Себебі',
  'feedback.action.noReason': 'Себепсіз',
  'feedback.action.closeBlocked':
    '«{status}» күйінен жабуға болмайды. Алдымен клиентке жауап беріңіз — жабу тек «Жауап берілді» күйінен мүмкін.',
  'feedback.action.assigneeEmpty': 'Қызметкерді таңдаңыз',
  'feedback.action.closeIt': 'Өтінішті жабу',
  'feedback.action.resolution': 'Қорытынды',
  'feedback.action.escalate': 'Эскалациялау',
  'feedback.action.note': 'Негіздеме',

  'feedback.category.suggested': 'болжам',
  'feedback.category.confirmed': 'расталған',
  'feedback.category.none': 'берілмеген',
  'feedback.category.suggestedHint':
    'Санатты алгоритм ұсынды. Оны адам растамайынша, өтініш есептілікке кірмейді.',
  'feedback.category.mustConfirm': 'Өтінішті санат расталғаннан кейін ғана жабуға болады.',

  'feedback.reports.title': 'Өтініштер бойынша есептер',
  'feedback.reports.sla': '{hours} сағаттан жылдам жауаптар үлесі',
  'feedback.reports.target': 'Мақсат — 95 %-дан төмен емес',
  'feedback.reports.total': 'Барлығы',
  'feedback.reports.closed': 'Жабылған',
  'feedback.reports.within': 'Мерзімінде',
  'feedback.reports.formula': 'Қалай есептейміз: {formula}',
  'feedback.reports.shareOfClosed': 'Жабылғандардан үлесі',
  'feedback.reports.share': 'Үлесі',
  'feedback.reports.avg': 'Орташа жауап уақыты, мин',
  'feedback.reports.openOverdue': 'Ашық мерзімі өткен',
  'feedback.reports.site': 'Нысан',
  'feedback.reports.network': 'Бүкіл желі',
  'feedback.reports.categories': 'Өтініш себептері',
  'feedback.reports.reason': 'Себебі',
  'feedback.reports.count': 'Саны',
  'feedback.reports.avgScore': 'Орташа баға',
  'feedback.reports.scores': 'Бағалардың таралуы',
  'feedback.reports.employees': 'Қызметкерлер бойынша',
  'feedback.reports.employee': 'Қызметкер',
  'feedback.reports.lowScore': 'Төмен бағалар',
  'feedback.reports.unconfirmed': 'Расталмаған санаттар: {n}',
  'feedback.reports.unlinked': 'Келуге байланбаған: {n}',

  'feedback.qr.title': 'Басып шығаруға арналған код',
  'feedback.qr.site': 'Нысан',
  'feedback.qr.generate': 'Токен алу',
  'feedback.qr.token': 'Форма токені',
  'feedback.qr.path': 'QR-код сілтемесі',
  'feedback.qr.hint':
    'Код нысанға бір рет басып шығарылады. Келу мен ауысым сканерлеу уақыты бойынша анықталады.',

  'feedback.common.loading': 'Жүктелуде…',
  'feedback.common.nothing': 'Ештеңе табылмады',
  'feedback.common.required': 'Міндетті өрістерді толтырыңыз',
  'feedback.common.forbidden': 'Бұл бөлімге құқық жеткіліксіз',
  'feedback.common.saved': 'Сақталды',
  'feedback.msg.queued': 'кезекте',
  'feedback.msg.sending': 'жіберілуде',
  'feedback.msg.sent': 'жіберілді',
  'feedback.msg.delivered': 'жеткізілді',
  'feedback.msg.failed': 'жеткізілмеді',
  'feedback.msg.suppressed': 'жіберілмеді',
  'feedback.tab.escalations': 'Эскалациялар',
  'feedback.tab.settings': 'Мерзімдер мен бағыттар',
  'feedback.tab.archive': 'Мұрағат',
  'feedback.qr.preview': 'Жапсырма осылай көрінеді',
  'feedback.qr.downloadSvg': 'Баспаханаға SVG жүктеу',
  'feedback.qr.downloadPng': 'PNG жүктеу',
  'feedback.qr.points': 'Нысан ішіндегі нүктелер',
  'feedback.qr.pointsHint': 'Әр посттың немесе кассаның өз коды бар. Өтініш қай нүктеде қалдырылғаны көрінеді.',
  'feedback.qr.pointName': 'Нүкте атауы',
  'feedback.qr.pointAdd': 'Нүкте қосу',
  'feedback.qr.pointFeedback': 'Пікірлер',
  'feedback.qr.pointRotate': 'Кодты қайта шығару',
  'feedback.qr.pointRotateHint': 'Ескі жапсырма жұмыс істемей қалады',
  'feedback.qr.pointArchive': 'Нүктені алып тастау',
  'feedback.qr.pointRestore': 'Қайтару',
  'feedback.qr.pointArchived': 'алынды',
  'feedback.qr.none': 'Нүктелер жоқ — нысанның ортақ коды жұмыс істейді.',
  'feedback.esc.title': 'Эскалациялар журналы',
  'feedback.esc.hint': 'Эскалация төмен баға, жауап мерзімі өткенде немесе қолмен бірден жасалады, басшы хабарлама алады. Мұнда кімге және неге екені көрінеді.',
  'feedback.esc.openOnly': 'Тек жауапсыздар',
  'feedback.esc.reason': 'Себебі',
  'feedback.esc.reason.low_score': 'Төмен баға',
  'feedback.esc.reason.overdue': 'Жауап мерзімі өтті',
  'feedback.esc.reason.manual': 'Қолмен',
  'feedback.esc.to': 'Кімге',
  'feedback.esc.nobody': 'алушы анықталмады',
  'feedback.esc.when': 'Қашан',
  'feedback.esc.empty': 'Эскалациялар жоқ',
  'feedback.card.escalations': 'Эскалациялар',
  'feedback.card.notifications': 'Жіберілген хабарламалар',
  'feedback.card.notificationsEmpty': 'Өтініш бойынша хабарлама жіберілмеген',
  'feedback.card.contact': 'Жауап үшін байланыс',
  'feedback.set.policy': 'Жауап мерзімі мен шектер',
  'feedback.set.policyHint': 'Жаңа мерзім сақталғаннан кейін түскен өтініштерге қолданылады. Бұрын қабылданғандар уәде етілген мерзімін сақтайды.',
  'feedback.set.scope': 'Кім үшін',
  'feedback.set.network': 'Бүкіл желі (әдепкі)',
  'feedback.set.response': 'Жауап мерзімі, мин',
  'feedback.set.remind': 'Еске салу, мин бұрын',
  'feedback.set.lowScore': 'Эскалациялау бағасы, жоғары емес',
  'feedback.set.visitWindow': 'Келуді іздеу терезесі, мин',
  'feedback.set.publicWindow': 'Форма шегінің терезесі, мин',
  'feedback.set.publicMax': 'Бір мекенжайдан терезедегі жіберу саны',
  'feedback.set.save': 'Сақтау',
  'feedback.set.reset': 'Желі саясатына қайтару',
  'feedback.set.override': 'ерекше мерзім',
  'feedback.set.rules': 'Бағыттау ережелері',
  'feedback.set.rulesHint': 'Ережелер басымдық бойынша тексеріледі: бірінші сәйкесі жауаптыны, эскалация алушысын және мерзімді тағайындайды.',
  'feedback.set.ruleName': 'Атауы',
  'feedback.set.ruleSite': 'Нысан',
  'feedback.set.ruleAnySite': 'кез келген',
  'feedback.set.ruleCategory': 'Санат',
  'feedback.set.ruleAny': 'кез келген',
  'feedback.set.ruleScore': 'Баға, жоғары емес',
  'feedback.set.ruleChannel': 'Арна',
  'feedback.set.ruleAssignee': 'Жауапты',
  'feedback.set.ruleEscalate': 'Эскалация',
  'feedback.set.ruleByRole': 'рөл бойынша',
  'feedback.set.ruleEmployee': 'нақты қызметкер',
  'feedback.set.ruleResponse': 'Өз мерзімі, мин',
  'feedback.set.rulePriority': 'Басымдық',
  'feedback.set.ruleNew': 'Жаңа ереже',
  'feedback.set.ruleEdit': 'Бағыттау ережесі',
  'feedback.set.ruleArchived': 'мұрағатта',
  'feedback.set.ruleArchive': 'Мұрағатқа',
  'feedback.set.ruleRestore': 'Қайтару',
  'feedback.role.site_manager': 'Нысан басқарушысы',
  'feedback.role.marketer': 'Маркетолог',
  'feedback.role.network_admin': 'Желі әкімшісі',
  'feedback.arch.title': 'Бұрынғы сервистің өтініштер мұрағаты',
  'feedback.arch.hint': 'Бөгде сервистен көшірілген тарих. Оның клиенттермен және келулермен байланысы жоқ — көзден солай келген.',
  'feedback.arch.search': 'Мәтін бойынша іздеу',
  'feedback.arch.found': 'Табылды: {n}',
  'feedback.arch.received': 'Алынды',
  'feedback.arch.subject': 'Тақырып',
  'feedback.arch.resolution': 'Жауап',
  'feedback.arch.prev': 'Артқа',
  'feedback.arch.next': 'Әрі қарай',
  'feedback.arch.empty': 'Мұрағаттан ештеңе табылмады',
  'feedback.sum.title': 'Кезең бойынша қорытынды',
  'feedback.sum.hint': 'Мәтін төмендегі есептердегі сандардан құралады, дәйексөздер — пікірлерден сөзбе-сөз. Тілдік модель қолданылмайды.',
  'feedback.sum.week': '7 күн',
  'feedback.sum.month': '30 күн',
  'feedback.sum.copy': 'Көшіру',
  'feedback.sum.copied': 'Қорытынды көшірілді',

};

export type FeedbackKey = keyof typeof RU;
export type FeedbackLocale = 'ru' | 'kk';

const DICTS: Readonly<Record<FeedbackLocale, Record<FeedbackKey, string>>> = { ru: RU, kk: KK };

export type FeedbackTranslate = (
  key: FeedbackKey,
  params?: Record<string, string | number>,
) => string;

export function makeFeedbackT(locale: FeedbackLocale): FeedbackTranslate {
  const dict = DICTS[locale] ?? RU;
  return (key, params) => {
    const template = dict[key] ?? RU[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}

export function translateFeedbackError(locale: FeedbackLocale, code: string): string {
  const dict = DICTS[locale] ?? RU;
  return (dict as Record<string, string>)[`errors.${code}`] ?? code;
}
